import { Tooltip } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

type plac =
  | 'left'
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top'
  | undefined;

export interface TooltipMapIconProps {
  children: ReactElement<any, any>;
  title: string;
  placement?: plac;
  followCursor?: boolean;
}

export const TooltipMapIcon: React.FC<TooltipMapIconProps> = ({
  children,
  title,
  placement = 'left',
  followCursor = false,
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      followCursor={followCursor}
      componentsProps={{
        popper: {
          sx: {
            div: {
              backgroundColor: (theme) => theme.palette.custom.tooltipBg,
              color: 'black',
              fontSize: '12px',
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};
